import { useRef, useState } from 'react'
import { View } from 'react-native'
import Page from '@shell/Page'
import Typography from '@ui/typography'
import {
  CofidisMonthlyApplicationForm,
  SectionModalLayout,
} from 'features/payment/cofidisMonthlyApplication'
import { SegmentedOption } from '@ui/elements/Segmented/types'
import Segmented from '@ui/elements/Segmented'
import Header from '@ui/elements/Header'
import useCofidisApplicationFormDefaults from 'features/payment/cofidisMonthlyApplication/useCofidisApplicationFormDefaults'
import { CofidisApplicationForm } from 'features/payment/cofidisMonthlyApplication/useCofidisApplicationForm'
import Button from '@ui/buttons/Button'

type LayoutMode = 'sections' | 'form'

const layoutModeOptions: SegmentedOption<LayoutMode>[] = [
  {
    id: 'sections',
    label: 'Sections',
  },
  {
    id: 'form',
    label: 'Full Form',
  },
]

export default function CofidisMonthlyApplicationDevPage() {
  const [layoutMode, setLayoutMode] = useState<LayoutMode>('sections')

  const cofidisApplicationFormRef = useRef<CofidisApplicationForm>(null)

  const defaultValues = useCofidisApplicationFormDefaults()

  const handleSubmit = () => {
    cofidisApplicationFormRef.current?.handleSubmit(
      console.log,
      console.error
    )()
  }

  return (
    <Page stage="dev">
      <Header
        title="Cofidis Monthly Application"
        desc="View example form input form divided into sections and modals."
      />
      <View className="gap-8 px-8">
        <View className="flex flex-col items-center justify-start">
          <View className="flex flex-row items-center justify-start gap-4">
            <Typography variant="SM" className="text-black/50">
              Layout Mode
            </Typography>
            <Segmented<LayoutMode>
              options={layoutModeOptions}
              value={layoutModeOptions.find(
                (option) => option.id === layoutMode
              )}
              onChange={(option) => setLayoutMode(option.id as LayoutMode)}
            />
          </View>
        </View>
        <CofidisMonthlyApplicationForm
          LayoutComponent={
            layoutMode === 'sections' ? SectionModalLayout : undefined
          }
          defaultValues={defaultValues}
          formRef={cofidisApplicationFormRef}
          onSubmit={(payload) => {
            console.log('Cofidis Monthly Application submit', payload)
          }}
        />
      </View>
      {/* Simulate button outside of the form like in PaymentSettings */}
      {layoutMode === 'sections' && (
        <View className="flex-row justify-center gap-2 py-16">
          <Button label="Submit" onPress={handleSubmit} />
        </View>
      )}
    </Page>
  )
}
